export const API_BASE_PATH = process.env.REACT_APP_BASE_URL
export const GET_APP_LIST = 'api/v1/marketplace/apps'
export const GET_FEATURED_APPS = 'api/v1/marketplace/featuredApps'
export const GET_STAFF_PICKED_APPS = 'api/v1/marketplace/staffPickedApps'
export const SEARCH_RESULT_API = 'api/v1/marketplace/search/apps?searchTerm='
export const GET_FILTERS = 'api/v1/metadata/'
export const REQUEST_FOR_DEMO = 'api/v1/marketplace/contact/requestDemo'
